import { PreviewIcon } from '@/assets/icons';
import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import Tooltip from '../common/tooltip';
import DefineDocumentPreview from '../define-document-preview';
import {
	TDefineDocumentPreviewButtonProps,
	TDefineDocumentPreviewProps,
} from '../define-document-preview/define-document-preview.type';

const DefinePreviewFileServerButton = ({
	className,
	label = '미리보기',
	link,
	readonly,
	...props
}: Omit<
	TDefineDocumentPreviewButtonProps,
	'filesNoAcceptDownloadAndPreview' | 'isAllDocument' | 'isDocumentNotReadonly'
>) => {
	const [open, setOpen] = useState(false);

	const defineDocumentPreviewModal =
		useRef<FunctionComponent<TDefineDocumentPreviewProps>>();

	const onOpenModal = useCallback(() => {
		if (!defineDocumentPreviewModal.current) {
			defineDocumentPreviewModal.current = DefineDocumentPreview;
		}

		setOpen(true);
	}, [props]);

	const onCancel = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<>
			<Tooltip title="미리보기">
				<PreviewIcon className="cursor-pointer" onClick={onOpenModal} />
			</Tooltip>
			{defineDocumentPreviewModal.current && (
				<defineDocumentPreviewModal.current {...{ ...props, open, onCancel }} />
			)}
		</>
	);
};

export default memo(DefinePreviewFileServerButton);
